import React from 'react';
import styles from './styles';

const ChatHistoryItemAnon = () => (
  <div style={styles.anonWrapper}>
    <div style={styles.messageColumn}>
      <div style={styles.fillerRowOne} />
      <div style={styles.fillerRowTwo} />
      <div style={styles.fillerRowThree} />
    </div>
  </div>
);

export default ChatHistoryItemAnon;
